"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBundleDiscount = exports.isDiscountStackable = exports.filterDiscountsBySalesChannel = exports.sortDiscountsByLoyaltyCostAndDate = void 0;
const models_1 = require("../models");
// Utility function to sort a list of IDiscount by loyaltyCost and then by updateDate
const sortDiscountsByLoyaltyCostAndDate = (discounts) => {
    return discounts.sort((a, b) => {
        if (a.loyaltyCost < b.loyaltyCost) {
            return 1;
        }
        else if (a.loyaltyCost > b.loyaltyCost) {
            return -1;
        }
        else {
            return new Date(b.updateDate).getTime() - new Date(a.updateDate).getTime();
        }
    });
};
exports.sortDiscountsByLoyaltyCostAndDate = sortDiscountsByLoyaltyCostAndDate;
const filterDiscountsBySalesChannel = (discounts, salesChannel) => {
    return discounts.filter((discount) => {
        var _a, _b;
        return ((_a = discount.salesChannels) === null || _a === void 0 ? void 0 : _a.length) === 0 ||
            ((_b = discount.salesChannels) === null || _b === void 0 ? void 0 : _b.some((s) => s.id === salesChannel.id));
    });
};
exports.filterDiscountsBySalesChannel = filterDiscountsBySalesChannel;
const isDiscountStackable = ({ isStackable, applyType, products, }) => {
    if (isStackable === false)
        return isStackable;
    const shouldBeNonStackable = applyType === models_1.DiscountModels.ApplyTypes.PRODUCTS || (0, exports.isBundleDiscount)(applyType, products);
    return shouldBeNonStackable ? false : isStackable;
};
exports.isDiscountStackable = isDiscountStackable;
const isBundleDiscount = (applyType, products) => {
    const isCartDiscount = applyType.toString() === 'cart';
    if (!isCartDiscount)
        return false;
    return products.length > 0 && products.every((product) => product.type === 'include');
};
exports.isBundleDiscount = isBundleDiscount;
//# sourceMappingURL=discountsUtilities.js.map